export enum TypeDr {
  MODIFIEE = 'modifiée',
  INITIALE = 'initiale',
  TOUTES = 'toutes'
}
